export default __webpack_public_path__ + "KaTeX_Fraktur-Regular.2c629b06891ec24911f53781b38554fa.woff2";